import amplitude from 'amplitude-js';
import { User } from 'src/types/user';
import { Instance } from 'src/types/instance';
import { UserProperties } from 'src/types/amplitude';
import { amplitudeConfig } from 'src/config';

export const initAmplitude = () => {
  amplitude.getInstance().init(
    amplitudeConfig.apiKey,
    null,
    { secureCookie: true },
  );
};

export const setAmplitudeUserId = (userId) => {
  amplitude.getInstance().setUserId(userId);
};

export const setAmplitudeUserProperties = (key, value) => {
  amplitude.getInstance().setUserProperties({ [key]: value });
};

export const setUser = (user?: User, instance?: Instance) => {
  setAmplitudeUserId(user?.id);
  setAmplitudeUserProperties(UserProperties.INSTANCE_ID, instance?.id);
  setAmplitudeUserProperties(UserProperties.INSTANCE_NAME, instance?.name);
  setAmplitudeUserProperties(UserProperties.USERNAME, user?.employeeInternalId);
};

export const clearUser = () => {
  setAmplitudeUserId(null);
  amplitude.getInstance().regenerateDeviceId();
};

export const logAmplitudeEvent = (eventType, eventProperties = {}) => {
  if (!amplitude.getInstance().options.userId) {
    return;
  }

  const properties = {
    ...(eventProperties),
    origin: 'WEB',
  };

  amplitude.getInstance().logEvent(
    eventType,
    properties,
  );
};
